import { render, staticRenderFns } from "./detail-base.vue?vue&type=template&id=27a862b8&scoped=true"
import script from "./detail-base.vue?vue&type=script&lang=js"
export * from "./detail-base.vue?vue&type=script&lang=js"
import style0 from "./detail-base.vue?vue&type=style&index=0&id=27a862b8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a862b8",
  null
  
)

export default component.exports